import React, { Fragment, useState, useEffect,useContext } from 'react';
import propTypes from 'prop-types';
import Images from 'assets/images/imageData';
import Layout from 'components/sales/layout/layout';
import DivLayout from 'components/sales/divLayout/divLayout';
import TableSection from 'components/sales/tableSection/tableSection';
import localization from 'assets/localization/localization';
import PanelCardWithHeading from 'components/tickets/panelCardWithHeading';
import DocumentView from 'components/sales/downloadDocView/documentView';
import ModalPop from 'components/sales/modal/modal';
import { Button } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import moment from 'moment';
import { BaseUrl } from 'contexts/baseUrl/baseUrl';
import parse from 'html-react-parser';


const ViewTicket = ({
  fdTicketDetails,
  fdTicketListing = [],
  viewDetails,
  match,
}) => {
    const [listData, setListData] = useState();
    const [pageCount, setPageCount] = useState(0);
    const { baseUrl } = useContext(BaseUrl);
    const [isLoading, setIsLoading] = useState(false);
    const Headers = [
      'Freshdesk Id',
      'Message',
      'Created At'
    ];
  
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await viewDetails(match.params.id);
      setIsLoading(false);
    })();
  }, [viewDetails, match.params.id]);

  useEffect(() => {
    if (fdTicketDetails.history !== undefined &&
      fdTicketDetails?.history?.results !== undefined && fdTicketDetails.history?.results.length > 0) {
        const tableData = [
          'id',
        'message',
        'created_at'
      ];
      // fdTicketDetails.history.results[0]['message'] = parse(fdTicketDetails.history.results[0]['message']);
        const data = fdTicketDetails?.history?.results.map((element) =>
            Object.assign(
                ...tableData.map((key) => (
                  key === 'message' ? {['message']: parse(element?.message)} :
                  {[key]: element[key]}
                )),
            )
            )
        const sdata = fdTicketDetails?.history?.results.map((element) => parse(element['message']))
        if (data) {
            data && setListData(data);
        }
    }
}, [fdTicketDetails])

  return (
    <Fragment>
      <Layout
        title={localization.ticketDetails}
        // Buttons={headerBtns}
        isLoading={isLoading}
        isGoback
        linkFlag
        linkUrl={`${baseUrl}/fd-tickets`}
      >
        <PanelCardWithHeading title={localization.ticketDetails}>
          <div className="details-listing" style={{"marginBottom":"40px"}}>
            <DivLayout heading={localization.freshdeskId} data={fdTicketDetails.freshdesk_id} />
            <DivLayout
              heading={localization.subject}
              data={fdTicketDetails.subject}
            />
            <DivLayout
              heading={localization.description}
              data={fdTicketDetails.description}
              status={true}
            />
            <DivLayout
              heading={localization.priority}
              data={fdTicketDetails.priority}
            />
             <DivLayout
              heading={localization.category}
              data={fdTicketDetails.category}
            />
            <DivLayout
              heading={localization.status}
              data={fdTicketDetails.status}
            />
            <DivLayout heading={localization.reportedBy} data={fdTicketDetails.name} />
            <DivLayout
              heading={localization.reportedOn}
              data={fdTicketDetails.created_at}
            />
            <DivLayout
              heading={localization.closedOn}
              data={fdTicketDetails.closed_on}
            />
            <DivLayout
              heading={localization.agentName}
              data={fdTicketDetails.agent_name}
            />
            <DivLayout
              heading={localization.tags}
              data={fdTicketDetails.tags}
            />
            { fdTicketDetails.tat &&
              <DivLayout
                heading={localization.tat}
                data={fdTicketDetails.tat + ' day(s)'}
              />
            }
            { fdTicketDetails.image &&
              <DocumentView attachment={fdTicketDetails.image} />
            }
            { fdTicketDetails?.agent_name &&
              <DivLayout
              heading={`Agent Name`}
              data={fdTicketDetails.agent_name}
              />
            }
            { fdTicketDetails?.tags &&
              <DivLayout
              heading={`Internal Name`}
              data={fdTicketDetails.tags}
              />
            }
          </div>
          
        </PanelCardWithHeading>
        <PanelCardWithHeading>
          <TableSection
            data={listData}
            headers={Headers}/>
        </PanelCardWithHeading>
        
        
      
      </Layout>
    </Fragment>
  );
};
ViewTicket.propTypes = {
  viewDetails: propTypes.func,
};
export default ViewTicket;